import { useEffect, useState } from 'react';
import { noop } from 'lodash';

const regex = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;

const findExistingScript = (src: string): boolean => {
  const scripts: NodeListOf<HTMLScriptElement> = document.querySelectorAll(`script[src^="${src}"]`);

  for (let i = 0; i < scripts.length; i++) {
    if (regex.test(scripts[i].src)) return true;

    continue;
  }

  return false;
};

export function useScript(src: string): boolean {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect((): (() => void) => {
    if (!findExistingScript(src)) {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
      script.onload = (): void => {
        setIsLoaded(true);
      };
      return (): void => {
        document.body.removeChild(script);
      };
    } else {
      setIsLoaded(true);
      return noop;
    }
  }, [src]);
  return isLoaded;
}
